import { HandleNegativeOnHand } from "@redotech/crdb-enums/inventory/handle-negative-on-hand";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getImsSettings = {
  name: "getImsSettings" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    handleNegativeOnHand: z.enum(HandleNegativeOnHand).nullable(),
  }),
};
